module.exports = __webpack_public_path__ + "img/wen.e3e6df28.png";